import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export const impressionToingPopup = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TOING_POPUP,
        context,
    });
};

export const clickDismissToingPopup = (clickEvent: AnalyticsContextValue["clickEvent"], context: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_DISMISS_TOING_RE_ENFORCEMENT,
        context,
    });
};

export const clickYayToingPopup = (clickEvent: AnalyticsContextValue["clickEvent"], context: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_YAY_TOING_RE_ENFORCEMENT,
        context,
    });
};
